import axios from "axios";
import { getAPIUrl } from '../helpers/common'

const Axios = axios.create({
    baseURL: getAPIUrl()
})  

// Prerendered pages carry the API responses they were built with
// (<script id="isa-prerender-data">). The first page load answers those GETs
// from that data, so React shows the same content right away instead of a loader.
// While the prerender itself runs (window.__ISA_PRERENDER__), GET responses are recorded.
const requestKey = (config) => {
    const url = String(config.url || "").replace(/^\/+/, "")
    return `${url}?${JSON.stringify(config.params || {})}`
}

const readPrerenderData = () => {
    try {
        const el = document.getElementById("isa-prerender-data")
        const data = el ? JSON.parse(el.textContent) : null
        return data && data.path === window.location.pathname ? data : null
    } catch (err) {
        return null
    }
}

const prerenderData = typeof window !== "undefined" ? readPrerenderData() : null
const defaultAdapter = Axios.defaults.adapter

Axios.defaults.adapter = (config) => {
    const isGet = (config.method || "get").toLowerCase() === "get"
    const key = requestKey(config)
    if (
        isGet &&
        prerenderData &&
        window.location.pathname === prerenderData.path &&
        Object.prototype.hasOwnProperty.call(prerenderData.responses, key)
    ) {
        return Promise.resolve({
            data: prerenderData.responses[key],
            status: 200,
            statusText: "OK",
            headers: {},
            config,
            request: null,
        })
    }
    const response = defaultAdapter(config)
    if (isGet && typeof window !== "undefined" && window.__ISA_PRERENDER__) {
        response.then((res) => {
            if (res.status >= 200 && res.status < 300) {
                window.__ISA_PRERENDER__.responses[key] = res.data
            }
        }, () => {})
    }
    return response
}

export default Axios;
